<template>
  <svg width="12" height="12" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 3.42857H8V4.57143H0V3.42857Z" fill="#26BC2C" />
    <path
      d="M4.57143 4.99557e-08L4.57143 8H3.42857L3.42857 0L4.57143 4.99557e-08Z"
      fill="#26BC2C"
    />
  </svg>
</template>

<script>
export default {
  name: 'Add',
}
</script>

<style scoped></style>
